import React, { useState } from 'react';
import t from '@guestyci/localize/t.macro';
import {
  Input,
  Text,
  FormField,
  FormItem,
  FormLabel,
  FormControl,
} from '@guestyci/arc';
import { Eye, EyeOff } from '@guestyci/icons/system';

const PasswordInput = ({ form, isSubmitting, externalError }) => {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <FormField
      control={form.control}
      name="password"
      render={({ field, fieldState }) => (
        <FormItem>
          <FormLabel>
            {t('New password')}
          </FormLabel>
          <FormControl>
            <Input
              {...field}
              type={showPassword ? 'text' : 'password'}
              placeholder={t('Enter your password')}
              autoFocus
              autoComplete="new-password"
              disabled={isSubmitting}
              error={(!!fieldState.error && form.formState.isSubmitted) || !!externalError}
              suffix={
                field.value ? (
                  <button
                    type="button"
                    onClick={() => setShowPassword(!showPassword)}
                    className="gst-p-0 gst-border-0"
                    aria-label={showPassword ? t('Hide password') : t('Show password')}
                  >
                    {showPassword ? (
                      <EyeOff className="gst-h-5 gst-w-5 gst-text-muted-foreground" />
                    ) : (
                      <Eye className="gst-h-5 gst-w-5 gst-text-muted-foreground" />
                    )}
                  </button>
                ) : null
              }
            />
          </FormControl>
          {fieldState.error && form.formState.isSubmitted && (
            <Text type="error">
              {t("Password doesn't meet the requirements below.")}
            </Text>
          )}
          {externalError && !fieldState.error && (
            <Text type="error">
              {externalError}
            </Text>
          )}
        </FormItem>
      )}
    />
  );
};

export default PasswordInput;
